<template>
  <div class="instance-profile-card" :class="[`theme-${theme}`, { 'is-fetching': _get(InstanceInfo, 'fetching'), 'is-no-logo': !isHaveLogo }]">

    <!-- <template v-if="true"> -->
    <template v-if="_get(InstanceInfo, 'fetching')">

      <div class="instance-profile-card__content">
        <div class="content__image-wrap">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
            <filter id="blur">
                <feGaussianBlur stdDeviation="15"></feGaussianBlur>
            </filter>
          </svg>
          <div class="background-mask">
            <div class="full-picture blur" :style="logoFirstBackgroundImage"></div>
          </div>
          <div class="image-circle">
            <i class="fal fa-spinner-third fa-spin"></i>
          </div>
        </div>
        <div class="content__title">
          <p class="content__title__name">
            <span class="loading-dot-blink"><span>.</span><span>.</span><span>.</span></span>
          </p>
        </div>
      </div>
    </template>

    <template v-else>

      <div class="instance-profile-card__content">

        <div class="content__image-wrap">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
            <filter id="blur">
                <feGaussianBlur stdDeviation="7"></feGaussianBlur>
            </filter>
          </svg>
          <div class="background-mask">
            <div class="background-mask__shade" v-if="isHaveLogo && maskShade"></div>
            <div class="full-picture blur" :style="logoFirstBackgroundImage"></div>
          </div>
          <div class="image-circle">
            <div class="image" :style="profileFirstBackgroundImage"></div>
          </div>
        </div>

        <div class="content__title">
          <p class="content__title__name">{{ personName || $t('label.welcome_to') }}</p>
          <p class="ui-element horizontal-divider">
            <span>{{ name }}</span>
          </p>
        </div>

      </div>
      <!-- end ~ instance-profile-card__content -->
    </template>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  name: 'instance-profile-card',
  props: {
    InstanceInfo: {
      type: Object,
      required: true,
      default: null,
    },
    PersonalProfile: {
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    mode: {
      type: String,
      required: false,
      default: 'default',
    },
    maskShade: {
      type: Boolean,
      default: true,
    },
    defaultLogo: {
      type: String,
      required: false,
      default: null,
    },
    defaultProfile: {
      type: String,
      required: false,
      default: '/static/logo/diet-creator-logo-square-white-turquose.svg',
    },
  },
  computed: {
    subdomain() {
      return get(this.InstanceInfo, 'data.subdomain');
    },
    name() {
      return get(this.InstanceInfo, 'data.name');
    },
    code() {
      return get(this.InstanceInfo, 'data.InstanceType.code') || 'professional';
    },
    personName() {
      return get(this.PersonalProfile, 'data.full_name');
    },
    logoFirstBackgroundImage() {
      return this.getBackgroundImage(true);
    },
    profileFirstBackgroundImage() {
      return this.getBackgroundImage(false);
    },
    isHaveLogo() {
      return get(this.InstanceInfo, 'data.Logo.path') !== undefined;
    },
  },
  methods: {
    getBackgroundImage(logo) {
      const logoPath = get(this.InstanceInfo, 'data.Logo.path') || '';
      const logoPicture = get(this.InstanceInfo, 'data.Logo.thumbnails.large.filename', '') || '';
      const logoFinal = logoPath ? `${process.env.IMAGES_ROOT}${logoPath}${logoPicture}` : this.defaultLogo;

      const profilePicturePath = get(this.PersonalProfile, 'data.ProfilePicture.path', '');
      const profilePicturePicture = get(this.PersonalProfile, 'data.ProfilePicture.thumbnails.large.filename', '');

      let profilePictureFinal = profilePicturePath ? `${profilePicturePath}${profilePicturePicture}` : false;
      profilePictureFinal = profilePictureFinal ? `${process.env.IMAGES_ROOT}${profilePictureFinal}` : (logoPath ? logoFinal : this.defaultProfile);

      const path = logo ? logoFinal : profilePictureFinal;

      return `backgroundImage: url(${path})`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/theme/person-colors";
@import '~styles/mixins/gradients';

$circle-border-color: #fff;
$circle-background-color: #fff;

.instance-profile-card {
  display: flex;
  align-self: stretch;
  flex-direction: column;
  justify-content: space-between;

  margin-bottom: 1.25em;

  .instance-profile-card__content {
    flex-grow: 1;
    display: flex;
    margin: 0.5em;
    overflow: hidden;
    align-self: stretch;
    flex-direction: column;
    border-top-left-radius: 0.5em;
    border-top-right-radius: 0.5em;

      .content__image-wrap {
        display: flex;
        flex-shrink: 0;
        overflow: hidden;
        position: relative;
        text-align: center;
        justify-content: center;

        svg {
          display: none;
        }

        .blur {
          transition: 1s;
          top: -5%; left: -5%;
          position: absolute;
          filter: url(#blur);
          filter: blur(7px);
          filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='7');
        }

        .full-picture {
          width: 110%;
          height: 110%;
          position: absolute;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
        }

        .image-circle {
          z-index: 1;
          width: 8em;
          height: 8em;
          margin-top: 4.5em;
          overflow: hidden;
          position: relative;
          border-radius: 50%;
          display: inline-block;
          border: 0.35em solid $circle-border-color;
          background-color: $circle-background-color;
          .image {
            width: 100%;
            height: 100%;
            top: 0; left: 0;
            position: absolute;
            background-size: auto 100%;
            background-repeat: no-repeat;
            background-position: center center;
          }
          i {
            opacity: 1;
            font-size: 4rem;
            line-height: 7rem;
            color: $primary-color;
          }
        }

        .background-mask {
          z-index: 0;
          width: 100%;
          height: 12em;
          top: 0; left: 0;
          overflow: hidden;
          position: absolute;
          background-color: #fff;
          clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);
          -webkit-clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);

          .background-mask__shade {
            top: 0;
            left: 0;
            right: 0;
            z-index: 2;
            height: 3.5em;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.25);
          }
        }
      }
      // end ~ content__image-wrap

      .content__title {
        text-align: center;
        margin: 0;

        .content__title__name {
          font-weight: 500;
          font-size: 1.1em;
        }

        .content__title__email {
          color: #e6e6e6;
        }

        .horizontal-divider, hr {
          margin: 0;
          span {
            font-weight: 600;
            font-size: 0.85rem;
            color: rgba(0,0,0, 0.5);
          }
        }
      }

  }
  // end ~ instance-profile-card__content

  &.is-no-logo {
    .instance-profile-card__content {
      .background-mask {
        background-color: rgba(0,0,0, 0.15);
      }
    }
  }

  &.is-fetching {
    .instance-profile-card__content {
      .image-circle {
        border-color: #fff;
        background-color: #d5d5d5;
        background-size: auto 75%;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url('~assets/images/diet-creator-loader-white.svg');
        .image {
          opacity: 1;
        }
        i {
          opacity: 1;
          color: #fff;
        }
      }
    }
  }

  &.theme-participant-area {
    margin: 0 0.5em 1em;
    .instance-profile-card__content {
      margin: 0;
      .content__image-wrap {
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
      }
      .content__title {
        margin-top: 1em;
        .content__title__name, .ui-element > span {
          color: #fff;
          text-shadow: 0 -1px 0 rgba(0,0,0, 0.25);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/card/instance-profile-card.vue